module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_vm._m(0), _vm._v(" "), (!_vm.userHasAccess) ? _c('div', [(_vm.user.membership_status === 'CANCELED') ? _c('ak-alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("Your coverage plan was cancelled. If you'd like to re-enable your coverage, ")]), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": 'mailto:' + _vm.SUPPORT_EMAIL + '?Subject=' + _vm.RE_ENABLE_PLAN
    }
  }, [_vm._v("please contact our billing\n        team.")])]) : _vm._e(), _vm._v(" "), (_vm.user.membership_status === 'UNPAID') ? _c('ak-alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("Your coverage plan is currently unpaid. Please proceed to "), _c('router-link', {
    staticClass: "color-theme",
    attrs: {
      "to": "/account/dashboard"
    }
  }, [_vm._v("Account Settings")]), _vm._v(" to resolve or ")], 1), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": 'mailto:' + _vm.SUPPORT_EMAIL + '?Subject=' + _vm.RE_ENABLE_PLAN
    }
  }, [_vm._v("contact our billing team")]), _vm._v(".\n    ")]) : _vm._e(), _vm._v(" "), (_vm.user.membership_status === 'PAST_DUE') ? _c('ak-alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("Your coverage plan is currently past due. Please proceed to "), _c('router-link', {
    staticClass: "color-theme",
    attrs: {
      "to": "/account/dashboard"
    }
  }, [_vm._v("Account Settings")]), _vm._v(" to resolve or ")], 1), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": 'mailto:' + _vm.SUPPORT_EMAIL + '?Subject=' + _vm.RE_ENABLE_PLAN
    }
  }, [_vm._v("contact our billing team")]), _vm._v(".\n    ")]) : _vm._e(), _vm._v(" "), (_vm.user.membership_status === 'BANNED') ? _c('ak-alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("Your account has been banned. If you think this was done in error, ")]), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": 'mailto:' + _vm.SUPPORT_EMAIL + '?Subject=Inquiry Regarding Banned Account'
    }
  }, [_vm._v("please contact\n        our billing team.")])]) : _vm._e(), _vm._v(" "), (_vm.user.membership_status === 'INACTIVE') ? _c('ak-alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("Your coverage plan was cancelled. If you'd like to re-enable your coverage, ")]), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": 'mailto:' + _vm.SUPPORT_EMAIL + '?Subject=' + _vm.RE_ENABLE_PLAN
    }
  }, [_vm._v("please contact our billing\n        team.")])]) : _vm._e(), _vm._v(" "), (_vm.user.membership_status === 'INVALID_USER') ? _c('ak-alert', {
    attrs: {
      "color": "red"
    }
  }, [_c('span', [_vm._v("Your account has been marked as invalid by our system due to unpaid premiums or other account issues. If you think this was done in error, ")]), _vm._v(" "), _c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": 'mailto:' + _vm.SUPPORT_EMAIL + '?Subject=' + _vm.RE_ENABLE_PLAN
    }
  }, [_vm._v("please contact our billing\n        team.")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "no-underline mv4 db",
    attrs: {
      "to": "/add-device-category"
    }
  }, [_c('div', {
    staticClass: "color-theme"
  }, [_vm._v("← View all categories")])]), _vm._v(" "), (_vm.isEligibleForAkkoStudentUpgrade) ? _c('div', {
    staticClass: "lh-copy fw3 pt3"
  }, [_c('ak-alert', {
    staticClass: "f5",
    attrs: {
      "color": "red"
    }
  }, [_c('a', {
    staticClass: "color-theme",
    attrs: {
      "href": ("mailto:billing@getakko.com?subject=Please upgrade to AKKO Student Plan - " + (this.$store.state.user.email)),
      "rel": "noopener noreferrer",
      "target": "_blank"
    }
  }, [_vm._v("\n        Click here to upgrade to an " + _vm._s(_vm.coverage_upgrade.item_covered) + " Student Plan for\n        $" + _vm._s(_vm.coverage_upgrade_monthly_cost) + " more per month.\n      ")])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "grid-fourth mt4",
    class: [!_vm.userHasAccess ? 'pb5' : '']
  }, [_c('div', [_vm._m(1), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.device_type),
      expression: "device_type"
    }],
    staticClass: "b--black-20 pa2 mb2 db w-100 br1",
    class: {
      'not-allowed-text-color': _vm.isNotAllowedItemType(_vm.is_active_coverage_restrictions, _vm.coverage_restriction_details, _vm.device_type),
      'placeholder': _vm.device_type === ''
    },
    attrs: {
      "id": "device_type",
      "type": "text"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.device_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeItem($event)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a type of item")]), _vm._v(" "), _vm._l((_vm.types), function(type, index) {
    return (!_vm.isNotVisibleItemType(_vm.is_active_coverage_restrictions, _vm.coverage_restriction_details, type.name)) ? _c('option', {
      key: index,
      domProps: {
        "value": type.name.toLowerCase()
      }
    }, [_vm._v("\n          " + _vm._s(type.name) + "\n        ")]) : _vm._e()
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "other"
    }
  }, [_vm._v("Other")])], 2)]), _vm._v(" "), _c('div', [_vm._m(2), _vm._v(" "), (_vm.device_type === 'phone') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brand),
      expression: "brand"
    }],
    staticClass: "ba b--black-20 pa2 mb2 db w-100 br1",
    class: _vm.brand === '' ? 'placeholder' : '',
    attrs: {
      "id": "brand"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.brand = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changePhoneMake]
    }
  }, [_c('option', {
    staticClass: "placeholder",
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a brand")]), _vm._v(" "), _vm._l((_vm.allMakes), function(make) {
    return _c('option', {
      key: make,
      domProps: {
        "value": make
      }
    }, [_vm._v(_vm._s(make))])
  })], 2) : (_vm.brands && _vm.brands[_vm.device_type]) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brand),
      expression: "brand"
    }],
    staticClass: "ba b--black-20 pa2 mb2 db w-100 br1",
    class: _vm.brand === '' ? 'placeholder' : '',
    attrs: {
      "id": "brand"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.brand = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeBrand]
    }
  }, [_c('option', {
    staticClass: "placeholder",
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a brand")]), _vm._v(" "), _vm._l((_vm.brands[_vm.device_type]), function(name, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": name
      }
    }, [_vm._v(_vm._s(name))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "other"
    }
  }, [_vm._v("Other")])], 2) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brand),
      expression: "brand"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "brand",
      "type": "text"
    },
    domProps: {
      "value": (_vm.brand)
    },
    on: {
      "blur": function($event) {
        return _vm.toggleKeyboard(false)
      },
      "focus": function($event) {
        return _vm.toggleKeyboard(true)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.brand = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_vm._m(3), _vm._v(" "), (_vm.device_type === 'phone') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model),
      expression: "model"
    }],
    staticClass: "ba b--black-20 pa2 mb2 db w-100 br1",
    class: _vm.model === '' ? 'placeholder' : '',
    attrs: {
      "id": "model"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.model = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changePhoneModel]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a model")]), _vm._v(" "), _vm._l((_vm.filterModelsBySelectedMake(_vm.brand)), function(model) {
    return _c('option', {
      key: model,
      domProps: {
        "value": model
      }
    }, [_vm._v(_vm._s(model) + "\n        ")])
  })], 2) : (_vm.models && _vm.models[_vm.device_type] && _vm.models[_vm.device_type][_vm.brand]) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model),
      expression: "model"
    }],
    staticClass: "ba b--black-20 pa2 mb2 db w-100 br1",
    class: _vm.model === '' ? 'placeholder' : '',
    attrs: {
      "id": "model"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.model = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeModel]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a model")]), _vm._v(" "), _vm._l((_vm.models[_vm.device_type][_vm.brand]), function(name, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": name
      }
    }, [_vm._v(_vm._s(name))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "other"
    }
  }, [_vm._v("Other")])], 2) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model),
      expression: "model"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "model",
      "type": "text"
    },
    domProps: {
      "value": (_vm.model)
    },
    on: {
      "blur": function($event) {
        return _vm.toggleKeyboard(false)
      },
      "focus": function($event) {
        return _vm.toggleKeyboard(true)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model = $event.target.value
      }
    }
  })]), _vm._v(" "), (!_vm.isSchoolLaptopPlan && !_vm.isSchoolIpadPlan) ? _c('div', [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.price),
      expression: "price",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "flex-grow br5-box-left input-reset ba br--left b--black-20 pa2 br1 tr",
    attrs: {
      "id": "price",
      "type": "number"
    },
    domProps: {
      "value": (_vm.price)
    },
    on: {
      "blur": [_vm.enteredPricePhoneModel, function($event) {
        return _vm.$forceUpdate()
      }],
      "focus": function($event) {
        return _vm.toggleKeyboard(true)
      },
      "keypress": function($event) {
        return _vm.checkPriceLength($event, this.price.value)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.price = _vm._n($event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex items-center inter br5-box-right bg-black-10 pa2"
  }, [_vm._v(".00")])])]) : _vm._e(), _vm._v(" "), (this.device_type === 'laptop') ? _c('div', [_c('label', {
    staticClass: "f6 db mb2 inter",
    attrs: {
      "for": "model_number"
    }
  }, [_vm._v("Model\n        " + _vm._s(_vm.brand === 'Apple' && _vm.device_type === 'laptop' ? 'Year' : 'Number'))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model_number),
      expression: "model_number"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "model_number",
      "type": "text"
    },
    domProps: {
      "value": (_vm.model_number)
    },
    on: {
      "blur": function($event) {
        return _vm.toggleKeyboard(false)
      },
      "focus": function($event) {
        return _vm.toggleKeyboard(true)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.model_number = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), ((this.device_type === 'laptop' || this.device_type === 'tablet' || this.device_type === 'tv') && !_vm.isSchoolIpadPlan) ? _c('div', [_c('label', {
    staticClass: "f6 db mb2 inter",
    attrs: {
      "for": "screen_size"
    }
  }, [_vm._v("Screen Size")]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.screen_size),
      expression: "screen_size",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "flex-grow input-reset br5-box-left ba br--left b--black-20 pa2 mb2 br1 tr",
    attrs: {
      "id": "screen_size",
      "type": "tel"
    },
    domProps: {
      "value": (_vm.screen_size)
    },
    on: {
      "blur": [function($event) {
        return _vm.toggleKeyboard(false)
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "focus": function($event) {
        return _vm.toggleKeyboard(true)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.screen_size = _vm._n($event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex items-center inter br5-box-right bg-black-10 pa2 mb2"
  }, [_vm._v("in.")])])]) : _vm._e(), _vm._v(" "), (this.device_type === 'laptop' || this.device_type === 'phone') ? _c('div', [_c('label', {
    staticClass: "f6 db mb2 inter",
    attrs: {
      "for": "storage"
    }
  }, [_vm._v("Storage")]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.storage),
      expression: "storage",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "flex-grow input-reset br5-box-left ba br--left b--black-20 w-60 pa2 mb2 br1 tr",
    attrs: {
      "id": "storage",
      "type": "tel"
    },
    domProps: {
      "value": (_vm.storage)
    },
    on: {
      "blur": [function($event) {
        return _vm.toggleKeyboard(false)
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "focus": function($event) {
        return _vm.toggleKeyboard(true)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.storage = _vm._n($event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex items-center inter br5-box-right bg-black-10 pa2 mb2"
  }, [_vm._v("GB")])])]) : _vm._e(), _vm._v(" "), (this.device_type === 'phone') ? _c('div', [_c('label', {
    staticClass: "f6 db mb2 inter",
    attrs: {
      "for": "carrier"
    }
  }, [_vm._v("Carrier")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.carrier),
      expression: "carrier"
    }],
    staticClass: "b--black-20 pa2 mb2 db w-100 br1",
    class: _vm.carrier === '' ? 'placeholder' : '',
    attrs: {
      "id": "carrier"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.carrier = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select a carrier")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "att"
    }
  }, [_vm._v("AT&T")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "verizon"
    }
  }, [_vm._v("Verizon")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "tmobile"
    }
  }, [_vm._v("T-Mobile")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "sprint"
    }
  }, [_vm._v("Sprint")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "spectrum"
    }
  }, [_vm._v("Spectrum")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "xfinity"
    }
  }, [_vm._v("Xfinity")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "boost"
    }
  }, [_vm._v("Boost")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "metro"
    }
  }, [_vm._v("Metro")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "straighttalk"
    }
  }, [_vm._v("Straight Talk")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "mint"
    }
  }, [_vm._v("Mint Mobile")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "cricket"
    }
  }, [_vm._v("Cricket")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "google fi"
    }
  }, [_vm._v("Google Fi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "consumer-wireless"
    }
  }, [_vm._v("Consumer Wireless")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "other"
    }
  }, [_vm._v("Other")])])]) : _vm._e(), _vm._v(" "), (this.device_type === 'phone' && _vm.carrier === 'other') ? _c('div', [_c('label', {
    staticClass: "f6 db mb2 inter",
    attrs: {
      "for": "storage"
    }
  }, [_vm._v("Other Carrier")]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.device_carrier_other),
      expression: "device_carrier_other"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "device_carrier_other",
      "type": "text"
    },
    domProps: {
      "value": (_vm.device_carrier_other)
    },
    on: {
      "blur": function($event) {
        return _vm.toggleKeyboard(false)
      },
      "focus": function($event) {
        return _vm.toggleKeyboard(true)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.device_carrier_other = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (this.device_type === 'phone') ? _c('div', [_c('fieldset', {
    staticClass: "input-reset bn pa0 ma0"
  }, [_c('legend', {
    staticClass: "inter f6 b db mb2"
  }, [_vm._v("Do you pay in installments")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-around"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.installments),
      expression: "installments"
    }],
    staticClass: "dn",
    attrs: {
      "id": "installments1",
      "name": "installments",
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.installments, true)
    },
    on: {
      "change": function($event) {
        _vm.installments = true
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "flex-grow pv2 inter b br-0 ba tc br5-box-left br--left b--grey silver bg-white pointer",
    attrs: {
      "for": "installments1",
      "tabindex": "0"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.installments = true
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.installments),
      expression: "installments"
    }],
    staticClass: "dn",
    attrs: {
      "id": "installments2",
      "name": "installments",
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.installments, false)
    },
    on: {
      "change": function($event) {
        _vm.installments = false
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "flex-grow pv2 inter bl-0 b ba tc br5-box-right br--right b--grey silver bg-white pointer",
    attrs: {
      "for": "installments2",
      "tabindex": "0"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.installments = false
      }
    }
  }, [_vm._v("No")])])])]) : _vm._e(), _vm._v(" "), (this.device_type === 'laptop' || this.device_type === 'tv') ? _c('div', [_c('fieldset', {
    staticClass: "input-reset bn pa0 ma0"
  }, [_c('legend', {
    staticClass: "f6 inter b db mb2"
  }, [_vm._v("\n          " + _vm._s(this.device_type === 'tv' ? 'Is it a smart TV' : 'Is it touchscreen') + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-around"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.touchscreen),
      expression: "touchscreen"
    }],
    staticClass: "dn",
    attrs: {
      "id": "touchscreen1",
      "name": "touchscreen",
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.touchscreen, true)
    },
    on: {
      "change": function($event) {
        _vm.touchscreen = true
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "flex-grow pv2 tc b ba br-0 br5-box-left b--grey silver bg-white pointer",
    attrs: {
      "for": "touchscreen1",
      "tabindex": "0"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.touchscreen = true
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.touchscreen),
      expression: "touchscreen"
    }],
    staticClass: "dn",
    attrs: {
      "id": "touchscreen2",
      "name": "touchscreen",
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.touchscreen, false)
    },
    on: {
      "change": function($event) {
        _vm.touchscreen = false
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "flex-grow pv2 tc b ba bl-0 br5-box-right b--grey silver bg-white pointer",
    attrs: {
      "for": "touchscreen2",
      "tabindex": "0"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.touchscreen = false
      }
    }
  }, [_vm._v("No")])])])]) : _vm._e(), _vm._v(" "), (!_vm.isSchoolIpadPlan) ? _c('div', [_vm._m(5), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.condition),
      expression: "condition"
    }],
    staticClass: "b--black-20 pa2 mb2 db w-100 br1",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.condition = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "new"
    }
  }, [_vm._v("New")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "refurbished"
    }
  }, [_vm._v("Refurbished")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "used"
    }
  }, [_vm._v("Used (Gift/Private sale)")])])]) : _vm._e(), _vm._v(" "), (!_vm.isSchoolLaptopPlan && !_vm.isSchoolIpadPlan) ? _c('div', [_vm._m(6), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.purchased_at),
      expression: "purchased_at"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "purchased_at",
      "type": "text"
    },
    domProps: {
      "value": (_vm.purchased_at)
    },
    on: {
      "blur": function($event) {
        return _vm.toggleKeyboard(false)
      },
      "focus": function($event) {
        return _vm.toggleKeyboard(true)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.purchased_at = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.isSchoolLaptopPlan && !_vm.isSchoolIpadPlan) ? _c('div', [_vm._m(7), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.purchase_date),
      expression: "purchase_date"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "purchase_date",
      "max": _vm.todayString,
      "type": "date"
    },
    domProps: {
      "value": (_vm.purchase_date)
    },
    on: {
      "blur": function($event) {
        return _vm.toggleKeyboard(false)
      },
      "focus": function($event) {
        return _vm.toggleKeyboard(true)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.purchase_date = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "f6 db mb2 inter",
    attrs: {
      "for": "serial_number"
    }
  }, [_vm._v("Serial Number"), (_vm.device_type === 'tablet' || _vm.device_type === 'phone' || _vm.device_type === 'laptop') ? _c('span', {
    staticClass: "red"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.serial_number),
      expression: "serial_number"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "serial_number",
      "type": "text"
    },
    domProps: {
      "value": (_vm.serial_number)
    },
    on: {
      "blur": function($event) {
        return _vm.toggleKeyboard(false)
      },
      "focus": function($event) {
        return _vm.toggleKeyboard(true)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.serial_number = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.device_type === 'phone') ? _c('a', {
    staticClass: "red inter f7 no-underline",
    attrs: {
      "href": "https://help.getakko.com/en/articles/4641960-how-to-find-my-serial-number-on-an-iphone-samsung-or-google-phone",
      "target": "_blank"
    }
  }, [_vm._v("Click\n        here to find your serial number")]) : _vm._e()]), _vm._v(" "), (_vm.device_type === 'phone') ? _c('div', [_vm._m(8), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.imei),
      expression: "imei"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "imei",
      "maxlength": "16",
      "type": "text"
    },
    domProps: {
      "value": (_vm.imei)
    },
    on: {
      "blur": function($event) {
        return _vm.toggleKeyboard(false)
      },
      "focus": function($event) {
        return _vm.toggleKeyboard(true)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.imei = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.device_type === 'phone') ? _c('a', {
    staticClass: "red inter f7 no-underline",
    attrs: {
      "href": "https://help.getakko.com/en/articles/6082165-how-to-find-my-imei-number-on-an-iphone-samsung-or-google-phone",
      "target": "_blank"
    }
  }, [_vm._v("Click\n        here to find your IMEI number")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isSchoolIpadPlan) ? _c('div', [_vm._m(9), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nickname),
      expression: "nickname"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "nickname",
      "type": "text"
    },
    domProps: {
      "value": (_vm.nickname)
    },
    on: {
      "blur": function($event) {
        return _vm.toggleKeyboard(false)
      },
      "focus": function($event) {
        return _vm.toggleKeyboard(true)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nickname = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isSchoolLaptopPlan) ? _c('div', [_c('div', [_c('label', {
    staticClass: "f6 db mb2 inter",
    attrs: {
      "for": "nickname"
    }
  }, [_vm._v("Student name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.device_student_name),
      expression: "device_student_name"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "device_student_name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.device_student_name)
    },
    on: {
      "blur": function($event) {
        return _vm.toggleKeyboard(false)
      },
      "focus": function($event) {
        return _vm.toggleKeyboard(true)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.device_student_name = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.isSchoolLaptopPlan) ? _c('div', [_c('label', {
    staticClass: "f6 db mb2 inter",
    attrs: {
      "for": "price"
    }
  }, [_vm._v("Student school")]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.device_student_school),
      expression: "device_student_school"
    }],
    staticClass: "input-reset ba b--black-20 pa2 mb2 db w-100 br1",
    attrs: {
      "id": "device_student_school",
      "type": "text"
    },
    domProps: {
      "value": (_vm.device_student_school)
    },
    on: {
      "blur": function($event) {
        return _vm.toggleKeyboard(false)
      },
      "focus": function($event) {
        return _vm.toggleKeyboard(true)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.device_student_school = $event.target.value
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), (_vm.userHasAccess) ? _c('div', {
    staticClass: "mt4 mb5 mw5-ns"
  }, [_c('ak-button', {
    class: _vm.submitBtnClass,
    attrs: {
      "disabled": !_vm.formComplete,
      "block": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addDevice.apply(null, arguments)
      }
    }
  }, [_vm._v("Add Item\n    ")])], 1) : _vm._e(), _vm._v(" "), (_vm.user.payment_processor === 'PARTNER' && _vm.openPlanErrorModal) ? _c('ak-modal', {
    attrs: {
      "title": "Unsupported Item Type"
    },
    on: {
      "close": _vm.resetState
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "mb4"
  }, [_vm._v("Please refer to your plan's details for information on covered item types.")])]), _vm._v(" "), _c('div', {
    staticClass: "pa3 flex-ns flex-wrap justify-end",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "order-1 mb3 mb0-ns"
  }, [_c('router-link', {
    staticClass: "no-underline dib-ns",
    attrs: {
      "to": "/account/dashboard"
    }
  }, [_c('ak-button', {
    attrs: {
      "block": "",
      "primary": ""
    }
  }, [_vm._v("Go to Billing")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mr3-ns"
  }, [_c('ak-button', {
    attrs: {
      "block": "",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetState.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1)])]) : (_vm.openPlanErrorModal) ? _c('ak-modal', {
    attrs: {
      "title": "Upgrade Your Plan Now to Cover More Items!"
    },
    on: {
      "close": _vm.resetState
    }
  }, [(!_vm.isSchoolIpadPlan) ? _c('div', {
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('plan-upgrade-card', {
    attrs: {
      "title": _vm.akkoPlanUpgradeStrings.title,
      "subHeading": _vm.akkoPlanUpgradeStrings.subHeading,
      "planBenefitsSummary": _vm.akkoPlanUpgradeStrings.planBenefitsSummary,
      "planBenefitsLineItems": _vm.akkoPlanUpgradeStrings.planBenefitsLineItems,
      "deductibleItems": _vm.akkoPlanUpgradeStrings.deductibleItems,
      "priceIncrease": ("+$" + _vm.coverage_upgrade_monthly_cost)
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isSchoolIpadPlan) ? _c('div', {
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "mb4"
  }, [_vm._v("Your plan only protects your district-issued iPads.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pa3 flex-ns flex-wrap justify-end",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticClass: "order-1 mb3 mb0-ns"
  }, [_c('ak-button', {
    attrs: {
      "block": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.debounceMethod(function () { return _vm.updateCoverage(_vm.coverage_upgrade.id); })
      }
    }
  }, [_vm._v("Upgrade Now\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "mr3-ns"
  }, [_c('ak-button', {
    attrs: {
      "block": "",
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetState.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.primaryAccountHolderWithAdditionalPlans) ? _c('ak-modal', {
    staticClass: "bold",
    attrs: {
      "title": "Reminder"
    },
    on: {
      "close": _vm.resetState
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "mb4"
  }, [_vm._v("Each plan you registered has its own login. Each member of your group must login from their own\n        phone to add their device and verify it\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mb2"
  }, [_vm._v("The following plan holders each have their own login:")]), _vm._v(" "), _vm._l((this.$store.state.user.related_users), function(plan, index) {
    return _c('div', {
      key: index
    }, [_vm._v("\n        " + _vm._s(_vm.formattedPhone(plan.phone)) + " - " + _vm._s(plan.coverage_name) + "\n      ")])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "no-underline dib-ns",
    attrs: {
      "target": "_blank",
      "to": "/add-plan"
    }
  }, [_c('a', {
    staticClass: "color-theme inter mb4",
    attrs: {
      "rel": "noopener",
      "target": "_blank"
    }
  }, [_vm._v("Click here if you need coverage for additional\n          phones.")])])], 2)]) : _vm._e(), _vm._v(" "), (_vm.primaryAccountHolderWithoutAdditionalPlans) ? _c('ak-modal', {
    attrs: {
      "title": "Notice"
    },
    on: {
      "close": _vm.resetState
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "mb4"
  }, [_vm._v("\n        " + _vm._s(_vm.maxPhones === 1 ? 'Your plan only covers 1 phone.' : ("Your Plan only covers " + _vm.maxPhones + " phones")) + "\n      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "no-underline dib-ns",
    attrs: {
      "target": "_blank",
      "to": "/add-plan"
    }
  }, [_c('a', {
    staticClass: "color-theme inter mb4",
    attrs: {
      "rel": "noopener",
      "target": "_blank"
    }
  }, [_vm._v("Click here if you need coverage for additional\n          phones.")])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.showWrongPhoneCoverageModal) ? _c('ak-modal', {
    attrs: {
      "title": "This phone is not covered by your currently selected coverage"
    },
    on: {
      "close": _vm.resetState
    }
  }, [(!_vm.isSchoolIpadPlan) ? _c('div', {
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [(_vm.selectedPhoneModel) ? _c('div', [(_vm.wrongCoveragePriceDifference > 0) ? _c('div', {
    staticClass: "mb4"
  }, [_vm._v("\n          Your plan will be $" + _vm._s(_vm.wrongCoveragePriceDifference) + " more per\n          " + _vm._s(_vm.user.coverage_plan_interval === 'annual' ? 'year' : 'month') + " for your new " + _vm._s(_vm.selectedPhoneModel.make) + "\n          " + _vm._s(_vm.selectedPhoneModel.model) + ".\n        ")]) : _vm._e(), _vm._v(" "), (_vm.wrongCoveragePriceDifference < 0) ? _c('div', {
    staticClass: "mb4"
  }, [_vm._v("\n          Your plan will be $" + _vm._s(-_vm.wrongCoveragePriceDifference) + " less per\n          " + _vm._s(_vm.user.coverage_plan_interval === 'annual' ? 'year' : 'month') + " for your new " + _vm._s(_vm.selectedPhoneModel.make) + "\n          " + _vm._s(_vm.selectedPhoneModel.model) + ".\n        ")]) : _vm._e()]) : _c('div', [(_vm.wrongCoveragePriceDifference > 0) ? _c('div', {
    staticClass: "mb4"
  }, [_vm._v("\n          Your plan will be $" + _vm._s(_vm.wrongCoveragePriceDifference) + " more per\n          " + _vm._s(_vm.user.coverage_plan_interval === 'annual' ? 'year' : 'month') + ".\n        ")]) : _vm._e(), _vm._v(" "), (_vm.wrongCoveragePriceDifference < 0) ? _c('div', {
    staticClass: "mb4"
  }, [_vm._v("\n          Your plan will be $" + _vm._s(-_vm.wrongCoveragePriceDifference) + " less per\n          " + _vm._s(_vm.user.coverage_plan_interval === 'annual' ? 'year' : 'month') + ".\n        ")]) : _vm._e()]), _vm._v(" "), _c('ak-button', {
    staticClass: "w-auto",
    attrs: {
      "block": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.debounceMethod(_vm.updateCoverage)
      }
    }
  }, [_vm._v("Confirm")])], 1) : _vm._e(), _vm._v(" "), (_vm.isSchoolIpadPlan) ? _c('div', {
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "mb4"
  }, [_vm._v("Your plan only protects your district-issued iPads.")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showNoCoveredPhones) ? _c('ak-modal-with-only-body', {
    on: {
      "close": _vm.resetState
    }
  }, [_c('div', {
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('upgrade-home-plus-plan', {
    attrs: {
      "coverage_upgrade": _vm.coverage_upgrade_home_plan,
      "updateCoverage": _vm.updateCoverage,
      "resetState": _vm.resetState,
      "current_coverage_price": _vm.current_coverage_price
    }
  })], 1)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-end"
  }, [_c('span', {
    staticClass: "f2 b title-responsive"
  }, [_vm._v("Add new item")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "f6 db mb2 inter",
    attrs: {
      "for": "device_type"
    }
  }, [_vm._v("Item"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "f6 db mb2 inter",
    attrs: {
      "for": "brand"
    }
  }, [_vm._v("Brand"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "f6 db mb2 inter",
    attrs: {
      "for": "model"
    }
  }, [_vm._v("Model"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "f6 db mb2 inter",
    attrs: {
      "for": "price"
    }
  }, [_vm._v("Purchase price"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "f6 db mb2 inter"
  }, [_vm._v("Condition when purchased"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "f6 db mb2 inter",
    attrs: {
      "for": "nickname"
    }
  }, [_vm._v("Where was it purchased?"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "f6 db mb2 inter",
    attrs: {
      "for": "nickname"
    }
  }, [_vm._v("When was it purchased?"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "f6 db mb2 inter",
    attrs: {
      "for": "imei"
    }
  }, [_vm._v("IMEI"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "f6 db mb2 inter",
    attrs: {
      "for": "nickname"
    }
  }, [_vm._v("Nickname"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22184c28","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddDevice.vue
// module id = 1317
// module chunks = 0